.form-box {
  margin: 20px;
}
.form-box label {
  width: 200px;
  display: inline-block;
}
.form-box ix-upload {
  margin-top: 20px;
  width: 600px;
}
